import { useMutation, UseMutationResult } from '@tanstack/react-query';

import { HoldActionErrorDto, usePatronSession } from '@app/hooks';
import { makeRequest } from '@app/utils';

interface RemoveHoldRequestProps {
  holdId: string;
}

export const useRemoveHoldMutation = (): UseMutationResult<
  unknown,
  HoldActionErrorDto,
  RemoveHoldRequestProps
> => {
  const { externalSystemId } = usePatronSession();

  return useMutation(({ holdId }: RemoveHoldRequestProps) => {
    const patronPath = `/opac-patron/account/${externalSystemId}`;
    const holdPath = `/hold/${holdId}/cancel`;

    return makeRequest({
      url: `${patronPath}${holdPath}`,
      method: 'POST',
      data: { holdId },
    });
  });
};
